import { lazy, Suspense } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Header from "../Display/Header";
import Loader from "../Display/Loader";
import { Theme } from "../../data/style/Theme";
import { Outlet, Link } from "react-router-dom";
import * as routes from "../../data/links/routes";
import { useAuth } from "../../context/AuthContext";
import useScreenSize from "../../context/ScreenContext";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { AllCenteredColumn, MainTitle } from "../../data/style/Style";

const Menu = lazy(() => import("../Menu"));
const Notifications = lazy(() => import("../Display/Notifications"));
const SettingsDrawer = lazy(() => import("../Display/SettingsDrawer"));
const ConversionModal = lazy(() => import("../Modals/ConversionModal"));

const LoggedLayout = () => {
  const { user } = useAuth();
  const { size, mobileDevice } = useScreenSize();
  var [width, height] = size;
  return (
    <Stack
      overflow={"hidden"}
      height={mobileDevice ? height + "px" : "100vh"}
      gap={2}
      sx={{ background: Theme.palette.bg }}
    >
      <Box width={"100%"}>
        {user?.id ? (
          <Header />
        ) : (
          <Link to={routes.INDEX} style={{ textDecoration: "none" }}>
            <MainTitle
              ml={width < 600 ? 1 : 3}
              fontSize={width < 600 ? "1.2rem" : "1.7rem"}
            >
              GRIND <span style={{ color: Theme.palette.orange }}>PARTNER</span>
            </MainTitle>
          </Link>
        )}
      </Box>
      <Stack direction="row" gap={1} overflow={"hidden"}>
        {user?.id && (
          <Stack
            width={"8%"}
            minWidth={width < 700 ? "60px" : "70px"}
            overflow={"hidden"}
          >
            <Suspense>
              <Menu />
            </Suspense>
          </Stack>
        )}
        <Box width={"100%"} overflow={"hidden"}>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </Box>
      </Stack>
      {(width < 950 || mobileDevice) && (
        <Box position={"absolute"} right={5} bottom={5}>
          <Stack gap={0.5}>
            {user?.id && (
              <Suspense>
                <AllCenteredColumn
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: 3,
                    background: Theme.palette.card,
                    border: `1px solid ${Theme.palette.border}`,
                    fontSize: 17,
                    cursor: "pointer",
                  }}
                  // onClick={handleClick}
                >
                  <EmojiEventsIcon sx={{ color: Theme.palette.gold }} />
                </AllCenteredColumn>
                {/* <AllCenteredColumn
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: 3,
                    background: Theme.palette.card,
                    border: `1px solid ${Theme.palette.border}`,
                    fontSize: 17,
                    color: Theme.palette.textSub,
                    cursor: "pointer",
                  }}
                  // onClick={handleClick}
                >
                  ⚔️
                </AllCenteredColumn> */}
                <Notifications />
                <SettingsDrawer />
                <ConversionModal />
              </Suspense>
            )}
          </Stack>
        </Box>
      )}
    </Stack>
  );
};

export default LoggedLayout;
